module.exports = "\r\n\r\n\r\n.panel {\r\n  border: 1px solid #d1d6e6;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/announcement-components/edit-announcement/edit-announcement.component.css
// module id = ./src/app/announcement-components/edit-announcement/edit-announcement.component.css
// module chunks = main